/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;



// WEBPACK FOOTER //
// ../node_modules/lodash/_baseLodash.js